import React from 'react'

import Avatar from 'components/common/Avatar'
import Text from 'components/common/Text'
import { getIdentity } from 'helpers/twilio'

import { Avatars, AvatarWrapper } from './styles'

import { Row, Content } from '../../styles'

const getCopy = (studentNames = []) => {
    const names = studentNames.join(', ')
    let verb = studentNames.length > 1 ? ' +2 more are ' : ' is '
    verb =
        studentNames.length === 1 && studentNames[0] === 'You' ? ' are ' : verb
    return `${names} ${verb} the quietest.`
}

const MIN_STUDENTS_REQD = 4 // min 4 students needed to show this metric

// sort students array by activity (talktime) percentage in asc order
const sortStudentsByActivity = (student1, student2) =>
    student1.activity - student2.activity

const QuitestStudents = ({ userId, students = [], rowReverse = false }) => {
    if (students.length < MIN_STUDENTS_REQD) return null

    const studentNames = []
    const studentAvatars = students
        .sort(sortStudentsByActivity)
        .slice(0, 2)
        .map(({ name, user_id }, index) => {
            const isLastElem = index === 1
            const isLocal = userId === user_id
            const identity = getIdentity(`${user_id}:${name}`)
            studentNames.push(isLocal ? 'You' : identity.firstName)

            return (
                <AvatarWrapper
                    key={`qs-av-${identity.uuid}`}
                    rowReverse={rowReverse}
                    isLastElem={isLastElem}
                >
                    <Avatar uuid={identity.uuid} />
                </AvatarWrapper>
            )
        })

    if (!studentAvatars.length) return null

    return (
        <Row rowReverse={rowReverse}>
            <Content flexBasis={studentNames.length > 1 ? '65%' : '100%'}>
                <Text level="2" bold={false}>
                    {getCopy(studentNames)}
                </Text>
            </Content>
            <Avatars rowReverse={rowReverse}>{studentAvatars}</Avatars>
        </Row>
    )
}

export default QuitestStudents
